(() => {
  // App upload fields for the owner's Form 3520 and the trade reference sheet.
  const form3520Field = 'custom_field_19';
  const refDocField = 'custom_field_20';
  const fieldSteps = {
    company_name: 'business', custom_field: 'business', custom_field_3: 'business', custom_field_15: 'business', custom_field_16: 'business',
    address_autocomplete: 'business', country_code: 'business', address_line1: 'business', address_line2: 'business', postal_code: 'business', city: 'business', province_code: 'business',
    contact_first_name: 'people', contact_last_name: 'people', contact_phone: 'people', contact_email: 'people', custom_field_18: 'people', additional_contacts: 'people',
    custom_field_17: 'branch', custom_field_12: 'branch', custom_field_13: 'branch', custom_field_2: 'branch',
    [form3520Field]: 'branch', [refDocField]: 'credit',
    custom_field_4: 'credit', custom_field_5: 'credit', custom_field_6: 'credit', custom_field_7: 'credit', custom_field_8: 'credit', custom_field_9: 'credit', custom_field_10: 'credit', custom_field_11: 'credit',
    // Shown on whichever step is last: Account setup for pay at purchase, Credit application for credit.
    custom_field_14: 'final'
  };
  const allSteps = ['business', 'people', 'branch', 'credit'];
  const stepMinutes = { business: 1, people: 1, branch: 1, credit: 4 };
  // App option values are integration contracts (conditions and the review inbox use them).
  const creditValue = 'Apply for Net 30';
  const exemptionValue = 'Some or all purchases are exempt';
  const contractorTypes = ['Electrical contractor', 'General contractor / builder'];
  const payValue = 'Pay at purchase';
  // Home branch option for buyers outside the local area (app option value).
  const noBranchValue = 'Not applicable';
  // Beyond local delivery range, "Find the closest branch" picks Not applicable instead.
  const localMiles = 75;
  const branches = {
    'Warren': { lat: 42.4477309, lng: -83.0758232, address: 'warren_address' },
    'Waterford Township': { lat: 42.6922677, lng: -83.3896798, address: 'waterford_address' }
  };
  // [tab label, note shown under the tabs once chosen]
  const choiceCopy = {
    custom_field_12: { 'Our purchases are taxable': ['tax_no_title', 'tax_no_note'], [exemptionValue]: ['tax_yes_title', 'tax_yes_note'] },
    custom_field_2: { 'Pay at purchase': ['trade_title', 'trade_note'], [creditValue]: ['credit_title', 'credit_note'] }
  };
  const fill = (text, values) => Object.keys(values).reduce((out, key) => out.replace(`ACCOUNT_${key.toUpperCase()}`, String(values[key])), text);
  const milesBetween = (a, b) => {
    const rad = deg => deg * Math.PI / 180;
    const h = Math.sin(rad(b.lat - a.lat) / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(rad(b.lng - a.lng) / 2) ** 2;
    return 3958.8 * 2 * Math.asin(Math.sqrt(h));
  };

  // The app's address search (/apps/dev-b2b-portal/address_suggestions) often takes over 5 s or
  // returns a 500. The app aborts at 5 s, shows "Address lookup is temporarily unavailable" and
  // forces manual entry. Retry slow or failed searches here: a slow search gets a second attempt
  // at 2.5 s, a failed one is retried, and the first good answer wins. The app only sees a failure
  // when every attempt fails. Its own abort signal is not passed on; the app already ignores
  // answers to searches the visitor has typed past.
  if (window.fetch && !window.fetch.excelAddressRetry) {
    const nativeFetch = window.fetch.bind(window);
    const maxAttempts = 3;
    const usable = async response => {
      if (!response.ok) return false;
      try { return JSON.parse(await response.clone().text()).ok === true; } catch (error) { return false; }
    };
    const retryingFetch = (input, init) => {
      const url = typeof input === 'string' ? input : input && input.url;
      if (!url || !url.includes('/address_suggestions') || !init || String(init.method).toUpperCase() !== 'POST') return nativeFetch(input, init);
      const { signal, ...options } = init;
      return new Promise(resolve => {
        let settled = false;
        let started = 0;
        let running = 0;
        let lastFailure = null;
        const finish = response => { if (!settled) { settled = true; resolve(response); } };
        const failed = response => {
          running -= 1;
          if (response) lastFailure = response;
          if (started < maxAttempts) launch();
          else if (!running) finish(lastFailure || new Response('{}', { status: 503, headers: { 'Content-Type': 'application/json' } }));
        };
        const launch = () => {
          if (settled || started >= maxAttempts) return;
          started += 1;
          running += 1;
          nativeFetch(url, options).then(async response => {
            if (await usable(response)) { running -= 1; finish(response); } else failed(response);
          }, () => failed(null));
        };
        launch();
        setTimeout(launch, 2500);
      });
    };
    retryingFetch.excelAddressRetry = true;
    window.fetch = retryingFetch;
  }

  function mount(root) {
    if (root.dataset.accountMounted) return;
    root.dataset.accountMounted = 'true';
    const copy = JSON.parse(root.querySelector('[data-account-copy]').textContent);
    // Shopify escapes translation text before it is serialized into JSON.
    const copyDecoder = document.createElement('textarea');
    Object.keys(copy).forEach(key => { copyDecoder.innerHTML = copy[key]; copy[key] = copyDecoder.value; });
    const app = root.querySelector('[data-account-app]');
    let initialized = false;
    const initialize = () => {
      if (initialized) return;
      const form = app.querySelector('[data-b2b-form][data-b2b-submit-bound="1"]');
      const container = form?.querySelector('[data-b2b-custom-fields]');
      const fields = form ? [...form.querySelectorAll('[data-b2b-field]:not([data-b2b-static-field])')] : [];
      const field = key => fields.find(node => node.dataset.b2bField === key);
      if (!form || !container || !field('custom_field_17')?.querySelector('[role="radio"]') || !field('custom_field_4')) return;
      initialized = true;
      // A field's own controls only: the tax card also holds the exemption details and certificate upload.
      const ownControls = (node, selector) => [...node.querySelectorAll(selector)].filter(element => element.closest('[data-b2b-field], [data-account-exemption]') === node);
      const control = key => { const node = field(key); return node ? ownControls(node, 'input:not([type="hidden"]), select, textarea')[0] || ownControls(node, 'input')[0] : null; };
      const value = key => {
        const node = field(key);
        if (!node) return '';
        const checkbox = node.querySelector('input[type="checkbox"]');
        if (checkbox) return checkbox.checked ? checkbox.value : '';
        return String(control(key)?.value || '').trim();
      };
      const isCredit = () => value('custom_field_2') === creditValue;
      const steps = () => allSteps.filter(step => step !== 'credit' || isCredit());
      const lastStep = () => steps()[steps().length - 1];
      let current = 'business';
      let furthest = 0;
      let submittedCredit = false;
      let submittedExempt = false;
      let confirmed = false;
      const validated = new Set();
      const title = root.querySelector('[data-account-step-title]');
      const description = root.querySelector('[data-account-step-description]');
      const validation = root.querySelector('[data-account-validation]');
      const actions = root.querySelector('[data-account-actions]');
      const next = root.querySelector('[data-account-next]');
      const nextLabel = root.querySelector('[data-account-next-label]');
      const back = root.querySelector('[data-account-back]');
      const submit = form.querySelector('[data-b2b-submit]');
      form.noValidate = true;
      fields.forEach(node => { node.dataset.accountStep = fieldSteps[node.dataset.b2bField] || 'business'; });
      ['address_line1', 'city', 'postal_code', 'country_code', 'province_code'].forEach(key => {
        const input = control(key);
        if (input) input.dataset.b2bRequired = '1';
      });

      const setLabel = (key, text) => { const label = field(key)?.querySelector('[data-b2b-label]'); if (label) label.textContent = text; };
      const setHelp = (key, text) => {
        const help = field(key)?.querySelector('[data-b2b-help-text]');
        if (!help) return;
        help.textContent = text || '';
        help.hidden = !text;
      };
      setLabel('company_name', copy.business_name);
      setLabel('custom_field', copy.business_type);
      setLabel('address_autocomplete', `${copy.business_address} *`);
      setLabel('custom_field_17', copy.branch_label);
      setLabel('custom_field_12', copy.tax_label);
      setLabel('custom_field_13', copy.certificate_label);
      setLabel(form3520Field, copy.doc_form_3520_title);
      setLabel(refDocField, copy.doc_trade_refs_title);
      setLabel('custom_field_2', copy.payment_label);
      setLabel('custom_field_5', copy.credit_limit);
      ['custom_field_7', 'custom_field_10'].forEach(key => setLabel(key, copy.ref_contact));
      setHelp('custom_field_17', '');
      setHelp('custom_field_12', '');
      setHelp('custom_field_13', copy.certificate_hint);
      setHelp('custom_field_2', '');
      fields.forEach(node => {
        if (node.dataset.b2bField === 'additional_contacts') return;
        const label = node.querySelector('[data-b2b-label]');
        if (label && node.querySelector('[data-b2b-required="1"], [data-b2b-radio-required="1"]') && !label.textContent.endsWith(' *')) label.append(document.createTextNode(' *'));
      });
      const addressInput = field('address_autocomplete')?.querySelector('[data-b2b-address-autocomplete-input]');
      if (addressInput) addressInput.setAttribute('aria-required', 'true');
      const creditLimit = control('custom_field_5');
      creditLimit.type = 'number'; creditLimit.min = '1'; creditLimit.step = '1'; creditLimit.inputMode = 'decimal';
      ['custom_field_3', 'custom_field_4'].forEach(key => field(key)?.classList.add('excel-account-native-group'));
      const colleagues = field('additional_contacts');
      if (colleagues) {
        const hint = document.createElement('p');
        hint.className = 'excel-account__hint';
        hint.textContent = copy.colleagues_hint;
        colleagues.querySelector('[data-b2b-label]').after(hint);
      }
      const colleagueCards = () => [...(colleagues?.querySelectorAll('[data-b2b-colleague]') || [])];
      const colleagueValue = (card, key) => card.querySelector(`[data-b2b-colleague-input="${key}"]`)?.value.trim() || '';
      // The app adds an access select to each card when the form lets the applicant choose roles; its values (ordering, location_admin) set the Shopify role.
      const colleagueAccess = card => card.querySelector('[data-b2b-colleague-input="role"]');
      const accessLabels = { ordering: copy.colleague_access_ordering, location_admin: copy.colleague_access_admin };
      const accessHint = document.createElement('p');
      accessHint.className = 'excel-account__hint';
      accessHint.textContent = copy.colleagues_access_hint;
      accessHint.hidden = true;
      const decorateColleague = card => {
        const select = colleagueAccess(card);
        if (!select || select.dataset.accountAccess) return;
        select.dataset.accountAccess = 'true';
        select.closest('label').querySelector('[data-b2b-label]').textContent = copy.colleague_access;
        [...select.options].forEach(option => { if (accessLabels[option.value]) option.textContent = accessLabels[option.value]; });
      };
      // The access hint shows only while a card has an access choice.
      const syncColleagues = () => {
        colleagueCards().forEach(decorateColleague);
        accessHint.hidden = !colleagueCards().some(colleagueAccess);
      };
      if (colleagues) {
        colleagues.querySelector('.excel-account__hint').after(accessHint);
        const list = colleagues.querySelector('.b2b-registration-block__colleague-list');
        syncColleagues();
        if (list) new MutationObserver(syncColleagues).observe(list, { childList: true });
      }

      // Account setup: each question is a heading row, segmented tabs, and one note about the current choice.
      const setTitle = (choice, text) => {
        const label = choice.lastElementChild;
        label.replaceChildren();
        const titleNode = document.createElement('span');
        titleNode.className = 'excel-account__choice-title';
        titleNode.textContent = text;
        label.append(titleNode);
      };
      const setupHead = (key, number, description) => {
        const node = field(key);
        const head = document.createElement('div');
        head.className = 'excel-account__setup-head';
        const badge = document.createElement('span');
        badge.className = 'excel-account__setup-number';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = number;
        const titles = document.createElement('div');
        titles.className = 'excel-account__setup-titles';
        const legend = node.querySelector('[data-b2b-label]');
        legend.before(head);
        const descriptionNode = document.createElement('p');
        descriptionNode.className = 'excel-account__setup-desc';
        descriptionNode.textContent = description;
        titles.append(legend, descriptionNode);
        head.append(badge, titles);
        node.classList.add('excel-account__setup');
        const note = document.createElement('p');
        note.className = 'excel-account__choice-note';
        note.hidden = true;
        node.querySelector('[role="radiogroup"]').after(note);
        return { node, head, note, badge, number };
      };
      const setup = {};
      [['custom_field_17', 'branch_desc'], ['custom_field_12', 'tax_desc'], ['custom_field_2', 'payment_desc']].forEach(([key, description], index) => { setup[key] = setupHead(key, String(index + 1), copy[description]); });
      Object.keys(choiceCopy).forEach(key => field(key).querySelectorAll('[role="radio"]').forEach(choice => {
        const keys = choiceCopy[key][choice.dataset.choiceValue];
        if (keys) setTitle(choice, copy[keys[0]]);
      }));
      const branchChoices = [...field('custom_field_17').querySelectorAll('[role="radio"]')];
      branchChoices.forEach(choice => setTitle(choice, choice.dataset.choiceValue));
      const branchMiles = {};
      let closestBranch = '';
      let farMiles = '';
      const syncNotes = () => {
        const branchValue = value('custom_field_17');
        const branch = branches[branchValue];
        const branchNote = setup.custom_field_17.note;
        if (branch) branchNote.textContent = [copy[branch.address], branchMiles[branchValue] ? fill(copy.distance, { miles: branchMiles[branchValue] }) : '', branchValue === closestBranch ? copy.closest : ''].filter(Boolean).join(' · ');
        else if (branchValue === noBranchValue) branchNote.textContent = farMiles ? `${fill(copy.branch_far, { miles: farMiles })} ${copy.branch_na_note}` : copy.branch_na_note;
        branchNote.hidden = !branch && branchValue !== noBranchValue;
        Object.values(setup).forEach(item => {
          const answered = Boolean(value(item.node.dataset.b2bField));
          item.node.classList.toggle('excel-account__setup--answered', answered);
          item.badge.textContent = answered ? '✓' : item.number;
        });
        ['custom_field_12', 'custom_field_2'].forEach(key => {
          const keys = choiceCopy[key][value(key)];
          const text = keys && keys[1] ? copy[keys[1]] : '';
          setup[key].note.textContent = text;
          setup[key].note.hidden = !text;
        });
      };

      // Business type: show the app's select options as chips; the select keeps the submitted value.
      const typeSelect = control('custom_field');
      const chips = document.createElement('div');
      chips.className = 'excel-account__chips excel-account__field';
      chips.dataset.accountStep = 'business';
      chips.setAttribute('role', 'radiogroup');
      chips.setAttribute('aria-label', copy.business_type);
      [...typeSelect.options].filter(option => option.value).forEach(option => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'excel-account__chip';
        chip.setAttribute('role', 'radio');
        chip.dataset.chipValue = option.value;
        chip.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
        chip.append(document.createTextNode(option.textContent.trim()));
        chip.addEventListener('click', () => {
          typeSelect.value = option.value;
          typeSelect.dispatchEvent(new Event('input', { bubbles: true }));
          typeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
        chips.append(chip);
      });
      const chipButtons = [...chips.querySelectorAll('[role="radio"]')];
      const syncChips = () => chipButtons.forEach((chip, index) => {
        const on = chip.dataset.chipValue === typeSelect.value;
        chip.setAttribute('aria-checked', String(on));
        chip.tabIndex = on || (!typeSelect.value && index === 0) ? 0 : -1;
      });
      container.append(chips);

      const appendTemplate = selector => container.append(root.querySelector(selector).content.cloneNode(true));
      appendTemplate('[data-account-trade-template]');
      appendTemplate('[data-account-credit-template]');
      root.querySelector('[data-credit-detail="year_started"]').max = String(new Date().getFullYear());
      const licenseNode = container.querySelector('[data-account-license]');

      // Tax guidance opens from an (i) button beside the question.
      const taxGuide = container.querySelector('[data-account-tax-guide]');
      taxGuide.id = `excel-account-tax-guide-${Math.random().toString(36).slice(2, 8)}`;
      taxGuide.hidden = true;
      const taxInfo = document.createElement('button');
      taxInfo.type = 'button';
      taxInfo.className = 'excel-account__info';
      taxInfo.setAttribute('aria-expanded', 'false');
      taxInfo.setAttribute('aria-controls', taxGuide.id);
      taxInfo.setAttribute('aria-label', copy.tax_info);
      taxInfo.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="7.6" r=".6" fill="currentColor"/></svg>';
      taxInfo.addEventListener('click', () => {
        const open = taxGuide.hidden;
        taxGuide.hidden = !open;
        taxInfo.setAttribute('aria-expanded', String(open));
      });
      setup.custom_field_12.head.append(taxInfo);
      setup.custom_field_12.head.after(taxGuide);

      // Review & submit: the last step ends with one clearly marked card.
      const finalCard = document.createElement('div');
      finalCard.className = 'excel-account__final';
      finalCard.dataset.accountStep = 'final';
      const finalTitle = document.createElement('h3');
      finalTitle.textContent = copy.final_title;
      const finalText = document.createElement('p');
      finalText.className = 'excel-account__final-text';
      finalText.textContent = copy.final_text;
      finalCard.append(finalTitle, finalText);
      container.append(finalCard);
      const review = document.createElement('details');
      review.className = 'excel-account__review';
      const reviewToggle = document.createElement('summary');
      const reviewTitle = document.createElement('span');
      reviewTitle.textContent = copy.review;
      const reviewHint = document.createElement('span');
      reviewHint.className = 'excel-account__review-hint';
      reviewHint.textContent = copy.review_intro;
      reviewToggle.append(reviewTitle, reviewHint);
      const summary = document.createElement('div');
      summary.className = 'excel-account__summary';
      review.append(reviewToggle, summary);
      finalCard.append(review);

      const extraFields = [...container.querySelectorAll('[data-account-step]:not([data-b2b-field])')].filter(node => !node.parentElement.closest('[data-account-step]'));
      const nodes = [...fields, ...extraFields];
      const detail = key => root.querySelector(`[data-account-detail="${key}"]`)?.closest('[data-account-step]');
      ['company_name', 'custom_field_15', 'custom_field_16', 'contact_first_name', 'contact_last_name', 'contact_email', 'contact_phone', 'province_code', 'postal_code', 'custom_field_7', 'custom_field_8', 'custom_field_10', 'custom_field_11'].forEach(key => field(key)?.classList.add('excel-account__half'));

      // Branch finder.
      const branchField = field('custom_field_17');
      const branchTools = root.querySelector('[data-account-branch-tools]').content.cloneNode(true);
      const locate = branchTools.querySelector('[data-account-locate]');
      const locateLabel = branchTools.querySelector('[data-account-locate-label]');
      const locateStatus = branchTools.querySelector('[data-account-locate-status]');
      setup.custom_field_17.head.append(locate);
      setup.custom_field_17.head.after(locateStatus);
      const showLocateStatus = (text, error) => {
        locateStatus.textContent = text;
        locateStatus.hidden = false;
        locateStatus.classList.toggle('excel-account__locate-status--error', Boolean(error));
      };
      locate.addEventListener('click', () => {
        if (!navigator.geolocation) { showLocateStatus(copy.location_error, true); return; }
        locate.disabled = true;
        locateLabel.textContent = copy.finding;
        navigator.geolocation.getCurrentPosition(position => {
          const here = { lat: position.coords.latitude, lng: position.coords.longitude };
          const ranked = branchChoices.filter(choice => branches[choice.dataset.choiceValue]).map(choice => ({ choice, miles: milesBetween(here, branches[choice.dataset.choiceValue]) })).sort((a, b) => a.miles - b.miles);
          const shown = miles => miles < 10 ? miles.toFixed(1) : String(Math.round(miles));
          ranked.forEach(({ choice, miles }) => { branchMiles[choice.dataset.choiceValue] = shown(miles); });
          const noBranch = branchChoices.find(choice => choice.dataset.choiceValue === noBranchValue);
          if (ranked[0] && ranked[0].miles > localMiles && noBranch) {
            if (noBranch.getAttribute('aria-checked') !== 'true') noBranch.click();
            closestBranch = '';
            farMiles = String(Math.round(ranked[0].miles));
            locateStatus.hidden = true;
          } else if (ranked[0]) {
            if (ranked[0].choice.getAttribute('aria-checked') !== 'true') ranked[0].choice.click();
            closestBranch = ranked[0].choice.dataset.choiceValue;
            farMiles = '';
            locateStatus.hidden = true;
          }
          locate.disabled = false;
          locateLabel.textContent = copy.find_closest;
          render(false);
        }, () => {
          locate.disabled = false;
          locateLabel.textContent = copy.find_closest;
          showLocateStatus(copy.location_error, true);
        }, { timeout: 10000, maximumAge: 600000 });
      });

      // Documents. A box drives one file input, and a document can have several boxes: the tax
      // documents are uploaded in the tax question and shown again at the end, where they can be
      // replaced. Form 3372, Form 3520 and the trade reference sheet use the app's own upload fields,
      // so they are attached. The others stay in the browser for now: the app has no field for them,
      // and it uploads every file input inside its form, so their inputs live outside the form.
      const maxDocBytes = 12 * 1024 * 1024;
      const docTypes = /\.(pdf|jpe?g|png)$/i;
      const docHolder = document.createElement('div');
      docHolder.hidden = true;
      app.after(docHolder);
      const docFields = { form_3372: 'custom_field_13', form_3520: form3520Field, trade_refs: refDocField };
      const docState = {};
      const docFor = key => {
        if (docState[key]) return docState[key];
        const native = (docFields[key] && field(docFields[key])?.querySelector('input[type="file"]')) || null;
        const input = native || document.createElement('input');
        // Files are picked into their own input first, so a rejected pick keeps the files already chosen.
        const picker = document.createElement('input');
        [input, picker].filter(item => item !== native).forEach(item => {
          item.type = 'file';
          item.tabIndex = -1;
          docHolder.append(item);
        });
        input.accept = picker.accept = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';
        picker.multiple = input.multiple;
        const state = { key, input, native, picker, boxes: [], from: null };
        state.show = () => state.boxes.forEach(item => item.show());
        const changed = () => {
          if (native) input.dispatchEvent(new Event('change', { bubbles: true }));
          state.show();
          sync();
        };
        state.set = (files, item) => {
          const list = [...(files || [])].slice(0, input.multiple ? undefined : 1);
          state.boxes.forEach(box => { box.error.hidden = true; });
          const bad = list.find(file => !docTypes.test(file.name) || file.size > maxDocBytes);
          // The app also caps everything it uploads in one application at 12 MB.
          const bytes = files => [...files].reduce((total, file) => total + file.size, 0);
          const others = native ? Object.values(docState).filter(other => other !== state && other.native && docNeeded[other.key]()).reduce((total, other) => total + bytes(other.input.files), 0) : 0;
          if (bad || (native && others + bytes(list) > maxDocBytes)) {
            item.error.textContent = !bad ? copy.doc_total_too_large : docTypes.test(bad.name) ? copy.doc_too_large : copy.doc_wrong_type;
            item.error.hidden = false;
            return;
          }
          if (!list.length) return;
          const transfer = new DataTransfer();
          list.forEach(file => transfer.items.add(file));
          input.files = transfer.files;
          changed();
        };
        state.clear = () => {
          input.value = '';
          state.boxes.forEach(box => { box.error.hidden = true; });
          changed();
        };
        picker.addEventListener('change', () => {
          if (picker.files.length) state.set(picker.files, state.from);
          picker.value = '';
        });
        docState[key] = state;
        return state;
      };
      const bindBox = box => {
        const state = docFor(box.dataset.doc);
        const drop = box.querySelector('[data-doc-drop]');
        const item = { key: state.key, box, error: box.querySelector('[data-doc-error]') };
        item.show = () => {
          const files = [...state.input.files];
          drop.hidden = files.length > 0;
          box.querySelector('[data-doc-file]').hidden = !files.length;
          box.querySelector('[data-doc-name]').textContent = files.map(file => file.name).join(', ');
        };
        const pick = () => { state.from = item; state.picker.click(); };
        drop.addEventListener('click', pick);
        box.querySelector('[data-doc-replace]').addEventListener('click', pick);
        drop.addEventListener('dragover', event => { event.preventDefault(); drop.classList.add('excel-account__drop--over'); });
        drop.addEventListener('dragleave', () => drop.classList.remove('excel-account__drop--over'));
        drop.addEventListener('drop', event => {
          event.preventDefault();
          drop.classList.remove('excel-account__drop--over');
          state.set(event.dataTransfer.files, item);
        });
        box.querySelector('[data-doc-remove]').addEventListener('click', () => {
          state.clear();
          drop.focus();
        });
        state.boxes.push(item);
        item.show();
        return item;
      };
      const docSection = root.querySelector('[data-account-documents]');
      const creditDocList = docSection.querySelector('.excel-account__uploads');
      const taxDocKeys = ['form_3372', 'form_3520'];
      // The tax boxes sit in the tax question; copies show again at the end: in Documents with
      // credit, or in Review & submit without it.
      const taxUploads = document.createElement('div');
      taxUploads.className = 'excel-account__uploads';
      const endDocs = document.createElement('div');
      endDocs.className = 'excel-account__end-docs';
      endDocs.innerHTML = '<p class="excel-account__end-docs-title"></p><p class="excel-account__end-docs-desc"></p><div class="excel-account__uploads"></div>';
      endDocs.querySelector('.excel-account__end-docs-title').textContent = copy.end_docs_title;
      endDocs.querySelector('.excel-account__end-docs-desc').textContent = copy.end_docs_desc;
      const endDocList = endDocs.querySelector('.excel-account__uploads');
      taxDocKeys.forEach(key => {
        const original = creditDocList.querySelector(`[data-doc="${key}"]`);
        taxUploads.append(original.cloneNode(true));
        endDocList.append(original.cloneNode(true));
      });
      root.querySelector('[data-account-exemption]').append(taxUploads);
      finalText.after(endDocs);
      const docBoxes = [...root.querySelectorAll('[data-doc]')].map(bindBox);
      const refsWaived = () => Boolean(docState.trade_refs.native && docState.trade_refs.input.files.length);
      const docNeeded = {
        form_3372: () => value('custom_field_12') === exemptionValue,
        form_3520: () => value('custom_field_12') === exemptionValue && root.querySelector('[data-account-detail="exemption_reason"]').value === copy.exempt_owner,
        license: () => contractorTypes.includes(typeSelect.value),
        formation: () => ['llc', 'corporation', 'partnership'].some(key => root.querySelector('[data-credit-detail="structure"]').value === copy[key]),
        dba: () => Boolean(root.querySelector('[data-account-detail="dba"]').value.trim()),
        financials: () => Number(creditLimit.value) >= 25000,
        // Without the app field the sheet could not be sent, so the references stay required.
        trade_refs: () => isCredit() && Boolean(docState.trade_refs.native)
      };
      const syncDocs = () => {
        // The app's own upload fields are driven through the boxes.
        ['custom_field_13', form3520Field, refDocField].forEach(key => field(key)?.classList.add('excel-account__moved'));
        docBoxes.forEach(item => { item.box.hidden = !docNeeded[item.key](); item.show(); });
        const shown = list => [...list.querySelectorAll('[data-doc]')].some(box => !box.hidden);
        endDocs.hidden = isCredit() || !shown(endDocList);
        docSection.hidden = !shown(creditDocList);
        root.querySelector('.excel-account__refs-or').hidden = !docNeeded.trade_refs();
      };
      const docLines = keys => keys.map(key => docState[key]).filter(state => state && !state.native && state.input.files.length && docNeeded[state.key]()).map(state => `${copy[`doc_${state.key}_title`]}: ${[...state.input.files].map(file => file.name).join(', ')}`);

      // Owners & officers rows (credit only).
      const ownersBox = root.querySelector('[data-account-owners]');
      const ownerTemplate = root.querySelector('[data-account-owner-template]');
      const addOwner = root.querySelector('[data-account-owner-add]');
      const owners = () => [...ownersBox.querySelectorAll('[data-account-owner]')];
      const renumberOwners = () => {
        owners().forEach((owner, index) => {
          owner.querySelector('[data-account-owner-number]').textContent = `${copy.owner_label} ${index + 1}`;
          owner.querySelector('[data-account-owner-remove]').hidden = owners().length === 1;
        });
        addOwner.hidden = owners().length >= 4;
      };
      const createOwner = () => {
        ownersBox.append(ownerTemplate.content.cloneNode(true));
        renumberOwners();
        owners().at(-1).querySelectorAll('[data-owner-input]').forEach(input => { input.disabled = !isCredit(); });
      };
      createOwner();
      addOwner.addEventListener('click', () => {
        createOwner();
        validated.delete('credit');
        owners().at(-1).querySelector('input').focus();
      });
      ownersBox.addEventListener('click', event => {
        const remove = event.target.closest('[data-account-owner-remove]');
        if (!remove) return;
        remove.closest('[data-account-owner]').remove();
        renumberOwners();
        validated.delete('credit');
        sync();
        addOwner.focus();
      });
      const ownerLines = () => owners().map((owner, index) => {
        const item = key => owner.querySelector(`[data-owner-input="${key}"]`).value.trim();
        const parts = [item('name'), item('role'), item('share') ? `${item('share')}%` : '', item('contact')].filter(Boolean);
        return parts.length ? `${copy.owner_label} ${index + 1}: ${parts.join(', ')}` : '';
      }).filter(Boolean);

      // Trade references: three are required unless a reference sheet is attached, up to six in all.
      // References 1 and 2 are the app's own fields (custom_field_6–11); the rest are theme rows.
      const refsBox = root.querySelector('[data-account-references]');
      const refTemplate = root.querySelector('[data-account-reference-template]');
      const addRef = root.querySelector('[data-account-reference-add]');
      const refKeys = [['custom_field_6', 'custom_field_7', 'custom_field_8'], ['custom_field_9', 'custom_field_10', 'custom_field_11']];
      const minRefs = 3;
      const maxRefs = 6;
      const refRows = () => [...refsBox.querySelectorAll('[data-account-reference]')];
      const refInput = (row, key) => {
        const index = refRows().indexOf(row);
        const position = ['company', 'contact', 'phone'].indexOf(key);
        if (index < refKeys.length && position >= 0) return control(refKeys[index][position]);
        return row.querySelector(`[data-ref-input="${key}"]`);
      };
      const syncRefs = () => {
        const waived = refsWaived();
        refRows().forEach((row, index) => {
          row.querySelector('[data-account-reference-number]').textContent = `${copy.reference_label} ${index + 1}`;
          const remove = row.querySelector('[data-account-reference-remove]');
          if (remove) remove.hidden = index < minRefs;
          ['company', 'phone'].forEach(key => {
            const input = refInput(row, key);
            if (input) input.required = !waived;
            const text = `${copy[`ref_${key}`]}${waived ? '' : ' *'}`;
            if (index < refKeys.length) setLabel(refKeys[index][key === 'company' ? 0 : 2], text);
            else row.querySelector(`[data-ref-label="${key}"]`).textContent = text;
          });
        });
        addRef.hidden = refRows().length >= maxRefs;
        root.querySelector('[data-account-refs-note]').hidden = !waived;
      };
      const createRef = () => {
        refsBox.append(refTemplate.content.cloneNode(true));
        refRows().at(-1).querySelectorAll('[data-ref-input]').forEach(input => { input.disabled = !isCredit(); });
        syncRefs();
      };
      while (refRows().length < minRefs) createRef();
      addRef.addEventListener('click', () => {
        createRef();
        validated.delete('credit');
        refRows().at(-1).querySelector('input').focus();
      });
      refsBox.addEventListener('click', event => {
        const remove = event.target.closest('[data-account-reference-remove]');
        if (!remove) return;
        remove.closest('[data-account-reference]').remove();
        syncRefs();
        validated.delete('credit');
        sync();
        addRef.focus();
      });
      const emailLabel = copy.ref_email.replace(/\s*\(.*\)\s*$/, '');
      const refLines = () => refRows().map((row, index) => {
        const own = index < refKeys.length;
        const parts = (own ? ['email'] : ['company', 'contact', 'phone', 'email']).map(key => refInput(row, key)?.value.trim()).filter(Boolean);
        if (!parts.length) return '';
        return own ? `${copy.reference_label} ${index + 1} — ${emailLabel}: ${parts[0]}` : `${copy.reference_label} ${index + 1}: ${parts.join(', ')}`;
      }).filter(Boolean);

      allSteps.concat('final').forEach(step => {
        const ordered = nodes.filter(node => node.dataset.accountStep === step);
        if (step === 'business') {
          [field('company_name'), detail('dba'), field('custom_field_15'), field('custom_field_16'), field('custom_field'), chips, licenseNode, field('address_autocomplete'), field('country_code'), field('address_line1'), field('address_line2'), field('city'), field('province_code'), field('postal_code'), field('custom_field_3')].filter(Boolean).forEach(node => container.append(node));
        } else if (step === 'people') {
          [field('contact_first_name'), field('contact_last_name'), field('custom_field_18'), field('contact_email'), field('contact_phone'), colleagues].filter(Boolean).forEach(node => container.append(node));
        } else if (step === 'branch') {
          [branchField, field('custom_field_12'), field('custom_field_2')].forEach(node => container.append(node));
          field('custom_field_12').append(...[detail('exemption_reason'), field('custom_field_13')].filter(Boolean));
        } else if (step === 'credit') {
          const creditFields = ordered.find(node => node.hasAttribute('data-account-credit-fields'));
          container.append(creditFields);
          creditFields.querySelector('[data-credit-slot="request"]').prepend(field('custom_field_5'));
          refKeys.forEach((keys, index) => {
            const email = creditFields.querySelector(`[data-credit-slot="reference_${index + 1}"] [data-ref-email]`);
            keys.forEach(key => email.before(field(key)));
          });
          container.append(field('custom_field_4'));
        } else {
          container.append(finalCard);
          if (field('custom_field_14')) finalCard.append(field('custom_field_14'));
        }
      });

      // Back / Continue live with the native submit button so they share one row.
      form.insertBefore(actions, submit);
      actions.append(submit);

      form.querySelectorAll('[role="radiogroup"]').forEach(group => {
        const radios = [...group.querySelectorAll('[role="radio"]')];
        group.addEventListener('keydown', event => {
          if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = radios.indexOf(event.target.closest('[role="radio"]'));
          const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? radios.length - 1 : (index + (['ArrowUp', 'ArrowLeft'].includes(event.key) ? -1 : 1) + radios.length) % radios.length;
          radios[nextIndex].click();
          radios[nextIndex].focus();
        });
      });
      const source = [location.pathname];
      const params = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(key => {
        const item = params.get(key);
        if (item) source.push(`${key}=${item.slice(0, 160)}`);
      });
      const serialize = (selector, dataset) => [...root.querySelectorAll(selector)].filter(input => !input.disabled && input.value.trim()).map(input => `${copy[input.dataset[dataset]]}: ${input.value.trim()}`);
      const write = (key, lines) => {
        const input = control(key);
        if (input) input.value = lines.join(input.tagName === 'TEXTAREA' ? '\n' : '; ');
      };
      const sync = () => {
        const docs = docLines(isCredit() ? Object.keys(docState) : taxDocKeys);
        const docNote = docs.length ? [`${copy.doc_selected}: ${docs.join(', ')}`] : [];
        write('custom_field_3', [...serialize('[data-account-detail]', 'accountDetail'), ...(isCredit() ? [] : docNote), `${copy.source}: ${source.join(' | ')}`]);
        write('custom_field_4', isCredit() ? [...serialize('[data-credit-detail]', 'creditDetail'), ...ownerLines(), ...refLines(), ...docNote] : []);
      };
      const relevant = node => node.dataset.accountStep !== 'credit' || isCredit();
      // Review & submit waits until the credit question is answered, so Account setup never ends early.
      const finalOn = step => step === lastStep() && (step !== 'branch' || Boolean(value('custom_field_2')));
      const onStep = (node, step) => node.dataset.accountStep === step || (node.dataset.accountStep === 'final' && finalOn(step));
      const clearErrors = () => {
        validation.hidden = true;
        root.querySelectorAll('[aria-invalid="true"]').forEach(node => node.removeAttribute('aria-invalid'));
        root.querySelectorAll('.excel-account__field-error:not([data-doc-error])').forEach(node => node.remove());
      };
      const errorOn = (node, message) => {
        node.setAttribute('aria-invalid', 'true');
        const parent = node.closest('.excel-account__chips, [data-b2b-field], .excel-account__field, label') || node.parentElement;
        const error = document.createElement('p');
        error.className = 'excel-account__field-error';
        error.textContent = message;
        parent.append(error);
      };
      const addressToggle = field('address_autocomplete').querySelector('[data-b2b-address-manual-toggle]');
      // The app keeps searching after a suggestion is picked. A late reply or 5-second timeout then
      // shows "lookup unavailable", reopens the list or forces manual entry over a filled address.
      // While the picked address stands, undo that noise.
      const addressFeedback = () => field('address_autocomplete').querySelector('[data-b2b-address-feedback]');
      const addressList = field('address_autocomplete').querySelector('[data-b2b-address-suggestions]');
      let picked = null;
      form.addEventListener('click', event => {
        const suggestion = event.target.closest('.b2b-registration-block__address-suggestion');
        if (suggestion) picked = { label: suggestion.textContent, manual: addressToggle?.getAttribute('aria-expanded') === 'true' };
        // Opening or closing manual entry by hand hands the address back to the visitor.
        if (event.isTrusted && event.target.closest('[data-b2b-address-manual-toggle]')) picked = null;
      }, true);
      // iOS drops a tap when leaving a field changes the page mid-press (the app reformats phone
      // numbers and collapses address details on blur). Replay a lost tap on the same control.
      const tappable = '[data-b2b-address-manual-toggle], [role="radio"], .excel-account__drop, [data-doc-replace], [data-doc-remove], .excel-account__locate, .excel-account__info, [data-account-back]';
      let pendingTap = null;
      root.addEventListener('pointerdown', event => {
        const target = event.pointerType === 'touch' && event.target.closest(tappable);
        pendingTap = target ? { target, x: event.clientX, y: event.clientY, clicked: false } : null;
      }, true);
      root.addEventListener('click', event => {
        if (pendingTap && event.target.closest(tappable) === pendingTap.target) pendingTap.clicked = true;
      }, true);
      root.addEventListener('pointerup', event => {
        const tap = pendingTap;
        if (!tap || Math.hypot(event.clientX - tap.x, event.clientY - tap.y) > 16) return;
        setTimeout(() => {
          if (tap.clicked || pendingTap !== tap || !tap.target.isConnected) return;
          pendingTap = null;
          if (tap.target.matches('[data-b2b-address-manual-toggle]')) picked = null;
          tap.target.click();
        }, 350);
      }, true);
      let quietQueued = false;
      const quietLookup = () => {
        quietQueued = false;
        if (!picked || !addressInput || addressInput.value !== picked.label || !value('address_line1') || !value('city') || !value('postal_code')) return;
        const feedback = addressFeedback();
        if (feedback && !feedback.hidden && !feedback.classList.contains('b2b-registration-block__field-hint--success')) feedback.hidden = true;
        if (addressList && !addressList.hidden) addressList.hidden = true;
        if (!picked.manual && addressToggle?.getAttribute('aria-expanded') === 'true') addressToggle.click();
      };
      new MutationObserver(() => {
        if (quietQueued) return;
        quietQueued = true;
        requestAnimationFrame(quietLookup);
      }).observe(field('address_autocomplete'), { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'class', 'aria-expanded'] });
      const invalidControl = step => {
        sync();
        const candidates = [...form.querySelectorAll('input, select, textarea')].filter(input => {
          const node = input.closest('[data-account-step]');
          return node && onStep(node, step) && relevant(node) && !input.disabled && !input.closest('[hidden]') && !node.classList.contains('excel-account-native-group') && !node.closest('[data-b2b-condition-hidden="1"]') && (!input.closest('[data-account-exemption]') || value('custom_field_12') === exemptionValue);
        });
        for (const input of candidates) {
          if (input.type === 'hidden') {
            if (input.hasAttribute('data-b2b-radio-required') && !input.value) return { input: input.parentElement.querySelector('[role="radio"]'), message: copy.radio_error };
            continue;
          }
          if (input === typeSelect && !typeSelect.value) return { input: chipButtons[0], message: copy.radio_error };
          if (!input.checkValidity()) return { input, message: input.validationMessage };
        }
        if (step === 'business') {
          const manual = addressToggle?.getAttribute('aria-expanded') === 'true';
          for (const key of ['address_line1', 'city', 'postal_code', 'country_code', 'province_code']) {
            const input = control(key);
            if (input && !input.disabled && !input.value.trim()) {
              if (!manual && addressInput && !value('address_line1')) return { input: addressInput, message: copy.address_required };
              if (addressToggle && !manual) addressToggle.click();
              return { input, message: copy.invalid };
            }
          }
        }
        if (step === 'credit') {
          const shares = owners().map(owner => owner.querySelector('[data-owner-input="share"]'));
          if (shares.reduce((total, input) => total + (Number(input.value) || 0), 0) > 100) return { input: shares.at(-1), message: copy.owner_share_total };
          // Backstop for the app's reference fields, whose required flag the app can reset.
          if (!refsWaived()) {
            for (const row of refRows()) {
              for (const key of ['company', 'phone']) {
                const input = refInput(row, key);
                if (input && !input.disabled && !input.value.trim()) return { input, message: copy.invalid };
              }
            }
          }
        }
        if (step === 'people') {
          const emails = new Set([value('contact_email').toLowerCase()]);
          for (const input of colleagues?.querySelectorAll('[data-b2b-colleague-input="email"]') || []) {
            const email = input.value.trim().toLowerCase();
            if (emails.has(email)) return { input, message: copy.colleague_email_unique };
            emails.add(email);
          }
        }
        return null;
      };
      const validate = step => {
        clearErrors();
        const invalid = invalidControl(step);
        if (!invalid) { validated.add(step); return true; }
        errorOn(invalid.input, invalid.message);
        validation.textContent = copy.invalid;
        validation.hidden = false;
        invalid.input.focus();
        invalid.input.scrollIntoView({ block: 'center' });
        return false;
      };
      const updateConditions = () => {
        const exempt = value('custom_field_12') === exemptionValue;
        root.querySelector('[data-account-exemption]').hidden = !exempt;
        const exemption = root.querySelector('[data-account-detail="exemption_reason"]');
        exemption.required = exempt;
        exemption.disabled = !exempt;
        if (!exempt) exemption.value = '';
        const contractor = contractorTypes.includes(typeSelect.value);
        licenseNode.hidden = !contractor;
        const license = licenseNode.querySelector('input');
        license.disabled = !contractor;
        if (!contractor) license.value = '';
        root.querySelectorAll('[data-credit-detail], [data-owner-input], [data-ref-input]').forEach(input => { input.disabled = !isCredit(); });
        if (!isCredit() && current === 'credit') current = 'branch';
      };
      // The app fills province_code from address search, but only hides its older
      // address detail keys. Keep the native province selector with manual entry.
      const syncProvince = () => {
        const province = field('province_code');
        if (!province || !addressToggle) return;
        const manual = addressToggle.getAttribute('aria-expanded') === 'true';
        province.classList.toggle('b2b-registration-block__field--address-detail-hidden', !manual);
        if (manual) province.removeAttribute('aria-hidden'); else province.setAttribute('aria-hidden', 'true');
        control('province_code').required = manual && !control('province_code').disabled;
      };
      if (addressToggle && field('province_code')) {
        const addressObserver = new MutationObserver(syncProvince);
        addressObserver.observe(addressToggle, { attributes: true, attributeFilter: ['aria-expanded'] });
        addressObserver.observe(control('province_code'), { attributes: true, attributeFilter: ['disabled'] });
      }
      const fieldValue = node => {
        const checked = node.querySelector('[role="radio"][aria-checked="true"]');
        if (checked) return checked.querySelector('.excel-account__choice-title')?.textContent || checked.dataset.choiceValue;
        const checkbox = node.querySelector('input[type="checkbox"]');
        if (checkbox) return checkbox.checked ? '✓' : '';
        const file = node.querySelector('input[type="file"]');
        if (file) return [...file.files].map(item => item.name).join(', ');
        const select = node.querySelector('select');
        if (select) return select.value ? select.selectedOptions[0].textContent : '';
        return String(node.querySelector('input:not([type="hidden"]), textarea, input')?.value || '').trim();
      };
      const buildSummary = () => {
        summary.replaceChildren();
        steps().filter(step => step !== current).forEach(step => {
          const section = document.createElement('section');
          section.className = 'excel-account__summary-section';
          const head = document.createElement('div');
          head.className = 'excel-account__summary-heading';
          const headingNode = document.createElement('h3');
          headingNode.textContent = copy[step];
          const edit = document.createElement('button');
          edit.type = 'button'; edit.textContent = copy.edit; edit.dataset.accountGo = step;
          edit.setAttribute('aria-label', `${copy.edit}: ${copy[step]}`);
          head.append(headingNode, edit);
          const list = document.createElement('dl');
          const add = (label, text) => {
            if (!text) return;
            const row = document.createElement('div');
            const dt = document.createElement('dt'); dt.textContent = label.replace(/\s*\*\s*$/, '');
            const dd = document.createElement('dd'); dd.textContent = text;
            row.append(dt, dd); list.append(row);
          };
          container.querySelectorAll('[data-b2b-field], [data-account-detail], [data-credit-detail]').forEach(node => {
            if (node.closest('[data-account-step]')?.dataset.accountStep !== step || node.closest('.excel-account-native-group, [data-b2b-condition-hidden="1"], [hidden]') || node.disabled) return;
            if (node.hasAttribute('data-account-detail')) add(copy[node.dataset.accountDetail], node.value);
            else if (node.hasAttribute('data-credit-detail')) add(copy[node.dataset.creditDetail], node.value);
            else if (!['additional_contacts', 'country_code', 'address_line1', 'address_line2', 'city', 'province_code', 'postal_code'].includes(node.dataset.b2bField)) {
              if (node.dataset.b2bField === 'address_autocomplete') {
                add(copy.business_address, [value('address_line1'), value('address_line2'), [value('city'), value('province_code'), value('postal_code')].filter(Boolean).join(' '), value('country_code')].filter(Boolean).join('\n'));
                return;
              }
              const label = node.querySelector('[data-b2b-label]')?.textContent || node.querySelector('label')?.textContent || '';
              let name = label.trim();
              const refIndex = refKeys.findIndex(keys => keys.includes(node.dataset.b2bField));
              if (refIndex >= 0) name = `${copy.reference_label} ${refIndex + 1} — ${name}`;
              add(name, fieldValue(node));
            }
          });
          if (step === 'people') {
            colleagueCards().forEach((card, index) => {
              const name = ['first_name', 'last_name'].map(key => colleagueValue(card, key)).filter(Boolean).join(' ');
              const titleValue = colleagueValue(card, 'title');
              const access = colleagueAccess(card)?.selectedOptions[0]?.textContent || '';
              const lines = [name, colleagueValue(card, 'email'), colleagueValue(card, 'phone'), titleValue ? `${copy.colleague_title}: ${titleValue}` : '', access ? `${copy.colleague_access}: ${access}` : ''].filter(Boolean);
              add(`${copy.colleague_name} ${index + 1}`, lines.join('\n'));
            });
          }
          if (step === 'credit') ownerLines().concat(refLines()).forEach(line => { const [label, ...rest] = line.split(': '); add(label, rest.join(': ')); });
          section.append(head, list); summary.append(section);
        });
      };
      const render = focus => {
        if (confirmed) return;
        updateConditions();
        syncProvince();
        syncChips();
        syncNotes();
        syncDocs();
        syncRefs();
        const activeSteps = steps();
        const index = activeSteps.indexOf(current);
        const isLast = finalOn(current);
        title.textContent = copy[current];
        description.textContent = copy[`${current}_intro`];
        root.querySelector('[data-account-progress]').textContent = fill(copy.progress, { current: index + 1, total: activeSteps.length });
        const remaining = activeSteps.slice(index).reduce((total, step) => total + stepMinutes[step], 0);
        root.querySelector('[data-account-time-text]').textContent = isLast && remaining <= 1 ? copy.last_step : fill(copy.time_left, { minutes: remaining });
        nodes.forEach(node => node.classList.toggle('excel-account-step-hidden', !onStep(node, current)));
        root.querySelectorAll('[data-account-step-item]').forEach(item => {
          const step = item.dataset.accountStepItem;
          const stepIndex = activeSteps.indexOf(step);
          item.hidden = stepIndex < 0;
          const button = item.querySelector('button');
          button.disabled = stepIndex > furthest;
          if (step === current) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
          const complete = validated.has(step) && step !== current;
          item.dataset.complete = String(complete);
          item.querySelector('.excel-account__step-number').textContent = complete ? '✓' : String(stepIndex + 1);
        });
        back.hidden = index === 0;
        next.hidden = isLast;
        nextLabel.textContent = current === 'branch' && isCredit() ? copy.next_credit : copy.next;
        submit.classList.toggle('excel-account-step-hidden', !isLast);
        actions.classList.toggle('excel-account__actions--final', isLast);
        // Pay-at-purchase accounts are auto-approved, so their button opens the account.
        finalText.textContent = isCredit() ? copy.final_text : copy.final_text_trade;
        if (!submit.disabled) submit.textContent = isCredit() ? copy.submit : copy.submit_trade;
        if (isLast) buildSummary();
        if (focus) {
          const header = document.querySelector('.site-header');
          title.style.scrollMarginTop = `${(header?.getBoundingClientRect().height || 0) + 24}px`;
          title.focus({ preventScroll: true }); title.scrollIntoView({ block: 'start' });
        }
      };
      const go = step => {
        clearErrors(); current = step; render(true);
      };
      const advance = () => {
        if (!validate(current)) return;
        const activeSteps = steps();
        const index = activeSteps.indexOf(current) + 1;
        furthest = Math.max(furthest, index);
        go(activeSteps[index]);
      };
      // Leaving a manual address field makes the app collapse the address panel, which moves
      // Continue mid-press and swallows the click. Capture the press and finish it on release.
      let press = null;
      let pressedAt = 0;
      next.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        press = { id: event.pointerId, x: event.clientX, y: event.clientY };
        try { next.setPointerCapture(event.pointerId); } catch (error) { /* capture is optional */ }
      });
      next.addEventListener('pointerup', event => {
        if (!press || press.id !== event.pointerId) return;
        // A press that drags away cancels, like a native button.
        const moved = Math.hypot(event.clientX - press.x, event.clientY - press.y) > 16;
        press = null;
        if (moved) return;
        pressedAt = Date.now();
        // The browser's own click follows at the old position, which may now be over a link.
        const swallow = clickEvent => { if (Date.now() - pressedAt < 800) { clickEvent.preventDefault(); clickEvent.stopPropagation(); } };
        document.addEventListener('click', swallow, { capture: true, once: true });
        setTimeout(() => document.removeEventListener('click', swallow, { capture: true }), 800);
        advance();
      });
      next.addEventListener('pointercancel', () => { press = null; });
      next.addEventListener('click', () => {
        if (Date.now() - pressedAt < 800) return;
        advance();
      });
      back.addEventListener('click', () => go(steps()[steps().indexOf(current) - 1]));
      root.addEventListener('click', event => {
        const target = event.target.closest('[data-account-go]');
        if (target && !target.disabled) go(target.dataset.accountGo);
        if (event.target.closest('[data-b2b-colleague-remove], .b2b-registration-block__colleague-add')) { validated.delete('people'); clearErrors(); }
      });
      form.addEventListener('input', () => { validated.delete(current); sync(); });
      form.addEventListener('change', () => { validated.delete(current); updateConditions(); sync(); render(false); });
      branchChoices.concat([...form.querySelectorAll('[data-b2b-field="custom_field_12"] [role="radio"], [data-b2b-field="custom_field_2"] [role="radio"]')]).forEach(choice => {
        choice.addEventListener('click', () => requestAnimationFrame(() => { validated.delete(current); updateConditions(); sync(); render(false); }));
      });
      form.addEventListener('keydown', event => {
        if (event.key !== 'Enter' || event.target.tagName === 'TEXTAREA' || event.target.closest('[role="radio"], button, a, summary, [data-b2b-address-autocomplete], [data-b2b-address-suggestions]')) return;
        if (current !== lastStep()) { event.preventDefault(); next.click(); }
      });
      form.addEventListener('submit', event => {
        if (confirmed) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        sync();
        for (const step of steps()) {
          const invalid = invalidControl(step);
          if (invalid) { event.preventDefault(); event.stopImmediatePropagation(); go(step); validate(step); return; }
        }
        if (current !== lastStep()) { event.preventDefault(); event.stopImmediatePropagation(); furthest = steps().length - 1; go(lastStep()); return; }
        clearErrors();
        // Don't send files for documents the answers no longer call for.
        Object.values(docState).forEach(state => { if (state.native && state.input.files.length && !docNeeded[state.key]()) state.input.value = ''; });
        submittedCredit = isCredit();
        submittedExempt = value('custom_field_12') === exemptionValue;
      }, true);
      const success = app.querySelector('[data-b2b-success]');
      if (success) new MutationObserver(() => {
        if (success.hidden || !success.textContent.trim() || confirmed) return;
        confirmed = true;
        clearErrors();
        app.hidden = true;
        root.querySelector('[data-account-step-header]').hidden = true;
        root.querySelector('[data-account-steps]').hidden = true;
        root.querySelector('[data-account-required]').hidden = true;
        const confirmation = root.querySelector('[data-account-confirmation]');
        root.querySelector('[data-account-confirmation-copy]').textContent = submittedCredit ? copy.credit_received : [copy.trade_received, submittedExempt ? copy.tax_yes_note : ''].filter(Boolean).join(' ');
        if (!submittedCredit) {
          root.querySelector('[data-account-confirmation-title]').textContent = copy.account_ready;
          root.querySelector('[data-account-sign-in]').hidden = false;
        }
        confirmation.hidden = false; confirmation.focus(); confirmation.scrollIntoView({ block: 'center' });
      }).observe(success, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
      root.querySelector('[data-account-step-header]').hidden = false;
      root.querySelector('[data-account-steps]').hidden = false;
      actions.hidden = false;
      root.dataset.accountReady = 'true';
      observer.disconnect();
      sync(); render(false);
    };
    const observer = new MutationObserver(initialize);
    observer.observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-b2b-submit-bound'] });
    initialize();
  }
  const scan = () => document.querySelectorAll('[data-excel-account]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
